import React from 'react';
import RefreshIcon from '@atlaskit/icon/glyph/refresh';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';
import { Wrapper, BottomWrapper, WarnIconWrapper, Message, RetryIconWrapper } from './styled.tsx';

type Props = {
	onRetry: () => Promise<void>;
};

const ErrorRetry = ({ onRetry }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper>
			<WarnIconWrapper>
				<WarningIcon label="" />
			</WarnIconWrapper>
			<BottomWrapper>
				<Message>{formatMessage(messages.unableToLoadData)}</Message>
				<RetryIconWrapper
					role="button"
					data-test-id="software-devops-report-common-error-retry.retry-icon-wrapper"
					onClick={() => onRetry()}
				>
					<RefreshIcon label={formatMessage(messages.retry)} size="small" />
				</RetryIconWrapper>
			</BottomWrapper>
		</Wrapper>
	);
};

export default ErrorRetry;
